<template>
  <div class="col-span-full sm:col-span-full md:col-span-7">
    <template v-if="!isLoading">
      <div v-html="extraHtml" />
    </template>

    <div>
      <keep-alive>
          <ajframe id="xpand-iframe" class="h-screen w-full" :src="fullUrl" v-on:load="iframeLoaded()" />
        </keep-alive>
      </div>
    <!--<iframe id="xpand-iframe" class="h-screen w-full" :src="fullUrl" v-on:load="iframeLoaded()" />-->

  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import Loader from '@/components/ui/loader';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import ajframe from '@/components/ajframe';
import { XPAND_BASEURL, IS_LOCALHOST } from '@/config';

export default {
  components: { Loader, ajframe, CardLoaderSmall },
  props: {
    xpandUrlPath: {
      type: String,
      required: false,
      default: '/xpandweb/internet/cm/startloggedon.aspx',
    },
    public: {
      type: Boolean,
      default: false,
    },
    menuId: {
      type: String,
    },
  },
  data() {
    return {
      actions: null,
      showLoader: true,
      isLoading: true,
      // testAlwaysLoading: true,
      cachedSSOQuery: null, // this.SSOQuery ändras varje ping, men ska inte användas förns man routat om. För att undvika att den ersätts.
    };
  },
  update() {
    if (this.actions) this.actions.destroy();
  },
  watch: {
    $route: {
      // deep : true,
      immediate: true, // bevaka vid mount
      handler() {
        this.showLoader = true;

        //När route ändras, kan SSOQueryString uppdateras.

        this.cachedSSOQuery = this.$store.getters.SSOQueryString;
      },
    },
  },
  computed: {
    // xpandUrlPath(){
    //   if(! this.$route.query || ! this.$route.query.url)
    //     return '/xpandweb/internet/cm/startloggedon.aspx';

    //   return this.$route.query.url
    // },
    fullUrl() {
      let URL = XPAND_BASEURL;

      let path = null;

      // if url passed in query, use it. otherwise, look in passed in property
      if (this.$route.query && this.$route.query.url) {
        path = this.$route.query.url;
      } else {
        path = this.xpandUrlPath;
      }

      // Alltid / efter domän.
      if (this.xpandUrlPath.charAt(0) != '/') {
        URL += '/' + path;
      } else {
        URL += path;
      }

      // Ska kommande GET parametrar va & eller ?
      if (path.indexOf('?') == -1) {
        URL += '?';
      } else {
        URL += '&';
      }

      // Lägg på ev SSOQueryString
      if (this.cachedSSOQuery && this.cachedSSOQuery !== 'undefined' && !this.public) {
        URL += this.cachedSSOQuery;
      }

      URL = URL.replace('https://stage.gavlegardarna.se/', '');

      return URL;
    },

    /**
     * Extra HTML som titel mm kan slängas in i Wordpressa admin, mappat på den URL man angivit.
     */
    extraHtml() {
      let path = null;

      if (this.$route.query && this.$route.query.url) {
        path = this.$route.query.url;
      } else {
        path = this.xpandUrlPath;
      }

      const hit = this.webapp_config.proxies_extra_html.find((row) => {
        return path.toLowerCase() == row.url.toLowerCase();
      });

      if (!hit) return;

      return hit.html;
    },

    ...mapGetters({
      authStatus: 'authStatus',
      webapp_config: 'webapp_config',
    }),
  },
  mounted() {
    this.showLoader = true; 
    this.isLoading = true;
  },
  methods: {
    iframeLoaded() {
      // Ta bort gamla lyssnare
      if (this.actions) {
        this.actions.destroy();
      }

      // iframe-communcations finns inte inte lokalt
      if (!IS_LOCALHOST) this.actions = window.Swift.iframe.applyActions('#xpand-iframe');

      // tar bort loadern, med lite fördröjning
        setTimeout(() => {
          this.showLoader = false;
          this.isLoading = false;
        }, 500);
    },
  },
};
</script>
